import config from "../../config/config";
import axios from "axios";
import { getToken } from "../../common";

// admin only: the bidder's change history, newest first
export const buyerHistoryAPI = async (buyerId) => {
  return await axios({
    method: "get",
    url: `${config.api.base_url}dashboard/buyers/${buyerId}/history`,
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: getToken(),
    },
  });
};

export default buyerHistoryAPI;
